document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('.prod-add-to-cart');
  const frameItems = document.querySelectorAll('.group-wrap .option-group .option-item');
  const batteryItems = document.querySelectorAll('.performace-options .option-item');
  
  let selectedColor = null;
  let selectedBattery = null;

  frameItems.forEach(item => {
    item.addEventListener('click', () => {
      frameItems.forEach(el => el.classList.remove('active'));
      item.classList.add('active');
  
      selectedColor = {
        standardUrl: item.dataset.standardUrl || '#',
        longUrl: item.dataset.longUrl || '#'
      };
  
      selectedBattery = null;
      addToCartBtn.href = '#';
      addToCartBtn.classList.remove('active');
      batteryItems.forEach(el => el.classList.remove('active'));
    });
  });
  
  batteryItems.forEach(item => {
    item.addEventListener('click', () => {
      if (!selectedColor) return;

      batteryItems.forEach(el => el.classList.remove('active'));
      item.classList.add('active');

      const title = item.querySelector('.label')?.textContent || '';
      selectedBattery = title.includes('Long') ? 'long' : 'standard';

      const href = selectedBattery === 'long' ? selectedColor.longUrl : selectedColor.standardUrl;
      addToCartBtn.href = href;
      addToCartBtn.classList.add('active');


      const priceBox = document.querySelector('.product-price');
      const newPrice = priceBox?.querySelector('.new-price');
      const oldPrice = priceBox?.querySelector('.old-price');

      if (selectedBattery === 'long') {
    
        if (newPrice) newPrice.style.display = 'none';

        if (oldPrice) {
          const del = oldPrice.querySelector('del');
          if (del) oldPrice.innerHTML = del.textContent;
        }
      } else {
        if (newPrice) newPrice.style.display = '';

        if (oldPrice && !oldPrice.querySelector('del')) {
          const text = oldPrice.textContent.trim();
          oldPrice.innerHTML = `<del>${text}</del>`;
        }
      }
    });
  });
  
  addToCartBtn.addEventListener('click', function (e) {
    if (!selectedColor || !selectedBattery) {
      e.preventDefault();
      alert(!selectedColor
        ? 'Please select a frame option (Step-Over or Step-Thru).'
        : 'Please select a performance option (Standard or Long-Range).'
      );
    }
  });
});
